import React, { Component } from 'react';
import classes from './WinList.css';

import ModuleLoadingSpinner from '../../components/UI/ModuleLoadingSpinner';
import ScrollTrigger from 'react-scroll-trigger';
import CustomScroll from 'react-custom-scroll';
import Moment from 'moment';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Hoc from '../../hoc/hoc';
import * as actions from '../../store/actions/index';

const MONTHS = [
	'Januar',
	'Februar',
	'Mart',
	'April',
	'Maj',
	'Jun',
	'Jul',
	'Avgust',
	'Septembar',
	'Oktobar',
	'Novembar',
	'Decembar',
  ];


class WinList extends Component {



	triggerAnimation = (event,ref,anim,delay) => {
		let del;
		if (delay!==undefined) {
			del=delay;
		} else {
			del='';
		}
		if (!ref.element.classList.contains('animated')) {
			ref.element.className="animated "+anim+" "+del;
		}
	}

	componentDidMount = () => {
		this.props.onGetDailyWinners();
		this.props.onGetWeeklyWinners();
	}

	/*
	componentWillReceiveProps (nextProps) {
		if (nextProps.dailyWinners !== null && nextProps.dailyWinners !== this.props.dailyWinners) {
			setLocalDailyWinners(nextProps.dailyWinners);
		}
	}

	setLocalDailyWinners (dw) {
		let localDW = [];
		dw.map( el => {

		})
	}
	*/


	render () {

		let dailyWinnerList = <ModuleLoadingSpinner/>;

		if (this.props.dailyWinners!==null) {
			if (this.props.dailyWinners!==false) {
				dailyWinnerList = [];
				for (var n in this.props.dailyWinners) {
					var day = Moment(this.props.dailyWinners[n]['day'],'YYYY-MM-DD').toDate();
					var stringDay = Moment(day).format('DD');
					var stringMonth = MONTHS[Moment(day).month()];
					//console.log(stringDay);
					dailyWinnerList.push(
						<div className={classes.winner} key={n}>
							<img src={this.props.dailyWinners[n]['avatar'] ? this.props.dailyWinners[n]['avatar'] : './avatar-blank.png'} alt=""/>
							<div className={classes.flexColumn}>
								<span><strong>{stringDay+'. '+stringMonth}</strong></span>
								<span style={{"textTransform": "capitalize"}}><strong>{(this.props.dailyWinners[n]['name']).toLowerCase()}</strong></span>
								<span>Tačnih odgovora: <strong>{this.props.dailyWinners[n]['answers']}</strong></span>
								<span>Rezultat: <strong>{this.props.dailyWinners[n]['result']}</strong></span>
							</div>
						</div>
					)
				}
			} else {
				dailyWinnerList = (
					<div className={classes.topListSubHeaderHighlight}>Nema proglašenih pobednika.</div>
				)
			}
		}
		
		let weeklyWinnerList = <ModuleLoadingSpinner/>;

		if (this.props.weeklyWinners!==null) {
			if (this.props.weeklyWinners!==false) {
				weeklyWinnerList = [];
				for (var m in this.props.weeklyWinners) {
					var week = Moment(this.props.weeklyWinners[m]['day'],'YYYY-MM-DD').toDate();
					var ts = week.getTime();
					let weekStr = '0. nedelja';
					if (ts >= 1536962400000 && ts < 1537567200000) {
						weekStr = '1. nedelja';
					} else if (ts >= 1537567200000 && ts < 1538172000000) {
						weekStr = '2. nedelja';
					} else if (ts >= 1538172000000 && ts < 1538776800000) {
						weekStr = '3. nedelja';
					} else if (ts >= 1538776800000 && ts < 1539381600000) {
						weekStr = '4. nedelja';
					} else if (ts >= 1539381600000 && ts < 1539900000000) {
						weekStr = '5. nedelja';
					} else if (ts >= 1539900000000 && ts < 1540504800000) {
						weekStr = '6. nedelja';
					}

					weeklyWinnerList.push(
						<div className={classes.winner} key={m}>
							<img src={this.props.weeklyWinners[m]['avatar'] ? this.props.weeklyWinners[m]['avatar'] : './avatar-blank.png'} alt=""/>
							<div className={classes.flexColumn}>
								<span><strong>{weekStr}</strong></span>
								<span style={{"textTransform": "capitalize"}}><strong>{(this.props.weeklyWinners[m]['name']).toLowerCase()}</strong></span>
								<span>Tačnih odgovora: <strong>{this.props.weeklyWinners[m]['answers']}</strong></span>
								<span>Rezultat: <strong>{this.props.weeklyWinners[m]['result']}</strong></span>
							</div>
						</div>
					)
				}
			} else {
				weeklyWinnerList = (
					<div className={classes.topListSubHeaderHighlight}>Nema proglašenih pobednika.</div>
				)
			}
		}


		return (
			<Hoc>
				<br/><br/>
				<div style={{width:'100%',textAlign:'center'}} >
					<h1 className={classes.h1Custom}>Dobitnici</h1>
				</div>

					<div className={classes.winnersContent}>
						<ScrollTrigger 
							onEnter={({progress,velocity},ref) => this.triggerAnimation({progress,velocity},ref,'rollIn')} 
							>
							<div 
								className={classes.winnerCardLeft}
							>
								{/*<img src="./dnevni.png" alt="Dnevni" style={{maxWidth:'210px',width:'90%'}} className={classes.winnerSubtitle}/>*/}
								<h3 className={classes.h3PresentTitle}>Dnevni</h3>
								<div className={classes.winnerList}>
									<CustomScroll flex="1">
										<div className={classes.winnerListScrollable}>
											{dailyWinnerList}
										</div>
									</CustomScroll>
								</div>
							</div>
						</ScrollTrigger>

						<ScrollTrigger 
							onEnter={({progress,velocity},ref) => this.triggerAnimation({progress,velocity},ref,'rollInRight','delay-1s')} 
							>
							<div 
								className={classes.winnerCardRight}
							>
								{/*<img src="./nedeljni.png" alt="Nedeljni" style={{maxWidth:'210px',width:'90%'}}  className={classes.winnerSubtitle}/>*/}
								<br/>
								<h3 className={classes.h3PresentTitle}>Nedeljni</h3>
								<div className={classes.winnerList}>
									<CustomScroll flex="1">
										<div className={classes.winnerListScrollable}>
											{weeklyWinnerList}
										</div>
									</CustomScroll>
								</div>
							</div>
						</ScrollTrigger>
					</div>

					<div className={classes.winnersContent}>
						<ScrollTrigger 
								onEnter={({progress,velocity},ref) => this.triggerAnimation({progress,velocity},ref,'pulse','infinite')} 
								>
								<div 
									className={classes.winnerCardMiddle}
								>
									<h3 className={classes.h3PresentTitle}>Glavni</h3>
									<div className={classes.winnerList}>
										<div className={classes.winner}>
											<img src="./avatar-blank.png" alt=""/>
											<span>Ljiljana Radovic</span>
										</div>
									</div>
								</div>
						</ScrollTrigger>
					</div>
				<br/><br/>
			</Hoc>

		);
	}
};


const mapStateToProps = state => {
	return {
		dailyWinners: state.res.dailyWinners,
		weeklyWinners: state.res.weeklyWinners,
	};
}

const mapDispatchToProps = dispatch => {
	return {
		onGetDailyWinners: () => dispatch(actions.getDailyWinners()),
		onGetWeeklyWinners: () => dispatch(actions.getWeeklyWinners()),
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WinList));


// WEBPACK FOOTER //
// ./src/containers/WinList/WinList.js